<app-navbar-logo />

<router-outlet></router-outlet>

<app-toast />
